import axios from "axios";
import { params, const_var } from "../../redux/reducers/common/stateObjects.js";
import {
	buildingSurfaceChange,
	changeLeantoPosition,
	fullyWrapClick,
	getPricingData,
	getPricingDataForLeanto,
	handleDeletedStateManuModal,
	handleIsResetBuildingState,
	handleLeanPorchPrices,
	selectCenterBuilding
} from "..";
import { buildingStyleChangeAccordingtoType, changeBuildingDimension, changeBuildingRoof, handleAccordionTab, buildingStyleChange } from "../building/building_style/buildingStyle.action";
import { getSidingOrientationOptions } from "../../helpers/building/building_material/buildingMaterial.helper";
import * as utils from "../../redux/reducers/utils";
import * as cuComponent from "../../redux/reducers/building_component/componentReducer.js";
import * as cuBuilding from "../../redux/reducers/building_pricing/pricingReducer.js";
import { selectLeanBuilding } from "../lean_building_pricing/api.actions.getPricingDataForLeanto";
import { checkAndupdateOtherInsulationSelection } from "../../helpers/insulation_pricing/insulationPricing.helper.js";
export function gaugeChange(e) {
	const_var.is_loader = true;
	return (dispatch) => {
		if (const_var != undefined && const_var.crmSetting.header_key == undefined) {
			const_var.crmSetting.header_key = { "x-api-key": "9vZYfym4VG99tLmdoqWYI8TYW01klRpr7ywM7SA5" };
			const_var.crmSetting.price_api_url = "https://api.senseicrm.com/";
		}
		let apiData = {};
		if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to")) {
			let chkFixedWidth = false;
			chkFixedWidth = const_var.c_m_a[params.p_b_t] ? (const_var.c_m_a[params.p_b_t].fixed_new_leg_width ? (const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0 ? true : false) : false) : false;
			if (params.cB_addStorage_check_right || params.cB_addStorage_check_left) {
				let utilitWidth = params.cB_addStorage_check_right == true ? params.cB_addStorage_right : params.cB_addStorage_left;
				let exactCalculation = 0;
				if (parseInt(utilitWidth) > params.p_w / 2) {
					exactCalculation = parseInt(Math.round(params.p_h - params.p_r_p) + Math.ceil((params.p_r_p / params.p_w) * utilitWidth));
				} else {
					exactCalculation = parseInt(Math.round(params.p_h - params.p_r_p) + Math.ceil((params.p_r_p / params.p_w) * utilitWidth));
				}
				if (exactCalculation > const_var.buildingHeightArray[const_var.buildingHeightArray.length - 1].value) {
					exactCalculation = const_var.buildingHeightArray[const_var.buildingHeightArray.length - 1].value;
				}

				apiData.center = {
					gauge: e,
					width: params.p_b_t == "2" ? params.p_w + 24 : params.p_w,
					height: params.p_h,
					single_slope_height:
						const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
							? Math.floor(params.p_h - (params.p_w * params.p_r_p) / 12)
							: Math.round(params.p_h - (params.p_w * params.p_r_p) / 12),
					length: params.p_d,
					map_id: const_var.Map_Id[params.p_b_t],
					roof_id: params.p_r_s,
					lean_to_height: 0,
					utility_width: parseInt(utilitWidth),
					pitch_height: exactCalculation,
					is_smaller_frame_width: chkFixedWidth
				};
			} else {
				apiData.center = {
					gauge: e,
					width: params.p_b_t == "2" ? params.p_w + 24 : params.p_w,
					height: params.p_h,
					single_slope_height:
						const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
							? Math.floor(params.p_h - (params.p_w * params.p_r_p) / 12)
							: Math.round(params.p_h - (params.p_w * params.p_r_p) / 12),
					length: params.p_d,
					map_id: const_var.Map_Id[params.p_b_t],
					roof_id: params.p_r_s,
					lean_to_height: 0,
					utility_length: params.p_u_c == true ? params.p_u_t : 0,
					front_utility_length: params.cB_addStorage_check_front ? Math.round(params.cB_addStorage_front) : 0,
					is_smaller_frame_width: chkFixedWidth
				};
			}
		} else {
			if (params.cB_addStorage_check_right || params.cB_addStorage_check_left) {
				let utilitWidth = params.cB_addStorage_check_right == true ? params.cB_addStorage_right : params.cB_addStorage_left;
				let exactCalculation = 0;
				if (parseInt(utilitWidth) > params.p_w / 2) {
					exactCalculation = parseInt(params.p_h) + parseInt(params.p_r_p);
				} else {
					exactCalculation = parseInt(params.p_h + Math.ceil((params.p_r_p / (params.p_w / 2)) * utilitWidth));
				}
				if (exactCalculation > const_var.buildingHeightArray[const_var.buildingHeightArray.length - 1].value) {
					exactCalculation = const_var.buildingHeightArray[const_var.buildingHeightArray.length - 1].value;
				}
				apiData.center = {
					gauge: e,
					width: params.p_b_t == "2" ? params.p_w + 24 : params.p_w,
					height: params.p_h,
					length: params.p_d,
					map_id: const_var.Map_Id[params.p_b_t],
					roof_id: params.p_r_s,
					lean_to_height: 0,
					utility_width: parseInt(utilitWidth),
					pitch_height: exactCalculation
				};
			} else {
				apiData.center = {
					gauge: e,
					width: params.p_b_t == "2" ? params.p_w + 24 : params.p_w,
					height: params.p_h,
					length: params.p_d,
					map_id: const_var.Map_Id[params.p_b_t],
					roof_id: params.p_r_s,
					lean_to_height: 0,
					utility_length: params.p_u_c == true ? params.p_u_t : 0,
					front_utility_length: params.cB_addStorage_check_front ? Math.round(params.cB_addStorage_front) : 0
				};
			}
		}
		if (params.add_left_lean == true || params.add_right_lean == true || params.add_back_lean == true || params.add_front_lean == true) {
			let LeanBuilding = const_var.Map_Id[params.p_b_t];
			if (const_var.SendAPIBuildingData !== undefined && const_var.SendAPIBuildingData.building !== undefined && const_var.SendAPIBuildingData.building.length > 0) {
				const_var.SendAPIBuildingData.building.map((item) => {
					if (item.building_type.heavy_snow == 1 && const_var.CheckSnowLoadValue == 65) {
						if (item.building_type.building_id == const_var.c_m_a[params.p_b_t].default_lean_id) {
							LeanBuilding = item.building_type.map_id;
						}
					}
					if (item.building_type.heavy_snow == 0 && const_var.CheckSnowLoadValue != 65) {
						if (item.building_type.building_id == const_var.c_m_a[params.p_b_t].default_lean_id) {
							LeanBuilding = item.building_type.map_id;
						}
					}
				});
			} else {
				if (const_var.c_m_a[params.p_b_t].defaultBuldingcheck == 1) {
					LeanBuilding = const_var.Map_Id[params.p_b_t];
				} else {
					LeanBuilding = const_var.mapIdforLean;
				}
			}

			//-------This code is for L&T building---------//
			var str = "";

			let porchLengthEnd = 0;
			let porchLengthSide = 0;

			let utilitWidth = 0;
			let exactCalculation = 0;
			if (params.cB_addStorage_check_right || params.cB_addStorage_check_left) {
				utilitWidth = params.cB_addStorage_check_right == true ? params.cB_addStorage_right : params.cB_addStorage_left;
				if (parseInt(utilitWidth) > params.p_w / 2) {
					exactCalculation = parseInt(params.p_h) + parseInt(params.p_r_p);
				} else {
					exactCalculation = parseInt(params.p_h + Math.ceil((params.p_r_p / (params.p_w / 2)) * utilitWidth));
				}
				if (exactCalculation > const_var.buildingHeightArray[const_var.buildingHeightArray.length - 1].value) {
					exactCalculation = const_var.buildingHeightArray[const_var.buildingHeightArray.length - 1].value;
				}
			}

			const getMapIdForLeanTo = (leanType) => {
				if (const_var.isLTBuilding && params.leanStyle[leanType] === "gable") {
					return const_var?.c_m_a?.[params.p_b_t]?.gable_mapping?.[0]?.map_id;
				}
				return LeanBuilding;
			};

			if (params.add_left_lean == true) {
				if (params.add_left_front_lean_porch == true) {
					porchLengthSide = parseInt(params.leanF_p_w);
				}
				if (params.add_left_back_lean_porch == true) {
					porchLengthSide = parseInt(params.leanB_p_w);
				}
				if (params.add_left_front_lean_porch == true && params.add_left_back_lean_porch == true) {
					porchLengthSide = parseInt(params.leanB_p_w) + parseInt(params.leanF_p_w);
				}
				str = params.add_left_lean;

				apiData.left = {
					gauge: e,
					width: params.lean_p_w,
					height: params.lean_p_h,
					length: params.lean_p_d + porchLengthSide,
					map_id: getMapIdForLeanTo("left"),
					roof_id: params.p_r_s,
					central_width: params.p_w,
					central_height: params.p_h,
					central_length: params.p_d,
					central_utility_length: params.p_u_c == true ? params.p_u_t : 0,
					central_utility_width: parseInt(utilitWidth),
					central_pitch_height: exactCalculation,
					utility_length: params.add_storage_check == true ? params.add_storage : 0,
					central_map_id: const_var.Map_Id[params.p_b_t]
				};
				if (const_var.isLTBuilding && params.leanStyle.left === "gable") {
					apiData["left"].is_l_and_t_building = true;
				}
			}
			if (params.add_right_lean == true) {
				if (params.add_right_front_lean_porch == true) {
					porchLengthSide = parseInt(params.leanF_p_w);
				}
				if (params.add_right_back_lean_porch == true) {
					porchLengthSide = parseInt(params.leanB_p_w);
				}
				if (params.add_right_front_lean_porch == true && params.add_right_back_lean_porch == true) {
					porchLengthSide = parseInt(params.leanB_p_w) + parseInt(params.leanF_p_w);
				}

				str = params.add_right_lean;
				apiData.right = {
					gauge: e,
					width: params.leanR_p_w,
					height: params.leanR_p_h,
					length: params.leanR_p_d + porchLengthSide,
					map_id: getMapIdForLeanTo("right"),
					roof_id: params.p_r_s,
					central_width: params.p_w,
					central_height: params.p_h,
					central_length: params.p_d,
					central_utility_length: params.p_u_c == true ? params.p_u_t : 0,
					central_utility_width: parseInt(utilitWidth),
					central_pitch_height: exactCalculation,
					utility_length: params.add_storage_check_right == true ? params.add_storage_right : 0,
					central_map_id: const_var.Map_Id[params.p_b_t]
				};
				if (const_var.isLTBuilding && params.leanStyle.right === "gable") {
					apiData["right"].is_l_and_t_building = true;
				}
			}
			if (params.add_front_lean == true) {
				if (params.add_right_front_lean_porch == true) {
					porchLengthEnd = parseInt(params.leanR_p_w);
				}
				if (params.add_left_front_lean_porch == true) {
					porchLengthEnd = parseInt(params.lean_p_w);
				}
				if (params.add_right_front_lean_porch == true && params.add_left_front_lean_porch == true) {
					porchLengthEnd = parseInt(params.lean_p_w) + parseInt(params.leanR_p_w);
				}
				str = params.add_front_lean;
				apiData.front = {
					gauge: e,
					width: params.leanF_p_w,
					height: params.leanF_p_h,
					length: params.leanF_p_d + porchLengthEnd,
					map_id: getMapIdForLeanTo("front"),
					roof_id: params.p_r_s,
					central_width: params.p_w,
					central_height: params.p_h,
					central_length: params.p_d,
					central_utility_length: params.p_u_c == true ? params.p_u_t : 0,
					central_utility_width: parseInt(utilitWidth),
					central_pitch_height: exactCalculation,
					utility_length: params.add_storage_check_front == true ? params.add_storage_front : 0,
					central_map_id: const_var.Map_Id[params.p_b_t]
				};
				if (const_var.isLTBuilding && params.leanStyle.front === "gable") {
					apiData["front"].is_l_and_t_building = true;
				}
			}
			if (params.add_back_lean == true) {
				if (params.add_right_back_lean_porch == true) {
					porchLengthEnd = parseInt(params.leanR_p_w);
				}
				if (params.add_left_back_lean_porch == true) {
					porchLengthEnd = parseInt(params.lean_p_w);
				}
				if (params.add_right_back_lean_porch == true && params.add_left_back_lean_porch == true) {
					porchLengthEnd = parseInt(params.lean_p_w) + parseInt(params.leanR_p_w);
				}

				str = params.add_back_lean;
				apiData.back = {
					gauge: e,
					width: params.leanB_p_w,
					height: params.leanB_p_h,
					length: params.leanB_p_d + porchLengthEnd,
					map_id: getMapIdForLeanTo("back"),
					roof_id: params.p_r_s,
					central_width: params.p_w,
					central_height: params.p_h,
					central_length: params.p_d,
					central_utility_length: params.p_u_c == true ? params.p_u_t : 0,
					central_utility_width: parseInt(utilitWidth),
					central_pitch_height: exactCalculation,
					utility_length: params.add_storage_check_back == true ? params.add_storage_back : 0,
					central_map_id: const_var.Map_Id[params.p_b_t]
				};
				if (const_var.isLTBuilding && params.leanStyle.back === "gable") {
					apiData["back"].is_l_and_t_building = true;
				}
			}
		}
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.front_utility_price_changed = true;
		const_var.UpdatedPriceData.left_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.left_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.left_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.left_lean_utility_price_changed = true;
		const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_utility_price_changed = true;
		const_var.UpdatedPriceData.front_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.front_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.front_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.front_lean_utility_price_changed = true;
		const_var.UpdatedPriceData.back_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.back_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.back_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.back_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.back_lean_utility_price_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		const_var.UpdatedPriceData.roof_color_price_changed = true;
		const_var.UpdatedPriceData.wall_color_price_changed = true;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
		const_var.UpdatedPriceData.truss_price_changed = true;
		dispatch({ type: "UPDATE_STATE" });
		return axios
			.post(const_var.crmSetting.price_api_url + "api/v1/pricing/gauge", apiData, { headers: const_var.crmSetting.header_key })
			.then(function (response) {
				if (response.data.data && response.data.data.center && response.data.data.center.data && response.data.data.center.data.length === 0) {
					/**
					 *  Handling old order and quotes whose whose model or pricing data has been deleted from intel
					 */
					dispatch(handleDeletedStateManuModal(true));
				} else {
					function updateBowsData(directionKey, leanDataKey) {
						const bows = response.data.data[directionKey]?.data?.bows;
					}
					if (params.add_left_lean && response.data?.data?.left?.data?.bows?.length > 0) {
						updateBowsData("left", "leanGetDataLeft");
					}
					if (params.add_right_lean && response.data?.data?.right?.data?.bows?.length > 0) {
						updateBowsData("right", "leanGetDataRight");
					}
					if (params.add_front_lean && response.data?.data?.front?.data?.bows?.length > 0) {
						updateBowsData("front", "leanGetDataFront");
					}
					if (params.add_back_lean && response.data?.data?.back?.data?.bows?.length > 0) {
						updateBowsData("back", "leanGetDataBack");
					}

					dispatch({
						type: "GAUGEACTION",
						value: e,
						apiResponseData: response.data.data
					});
				}
			})
			.catch(function (error) {
				console.log(error);
			})
			.finally(() => {
				const_var.is_loader = false;
			});
	};
}

export function addLTExtension(leanType) {
	return async (dispatch) => {
		let response = null;
		const str = `add${utils.capitalize(leanType)}Lean`;
		params[`add_${leanType}_lean`] = false;

		if (const_var.isLTBuilding == false) {
			const_var.lNTBuildingData.ExtraItemsFeaturesQuantityArray.centerBuilding = JSON.parse(JSON.stringify(const_var.ExtraItemsFeaturesQuantityArray ?? []));
			const_var.lNTBuildingData.extraAddOnItemsArray.centerBuilding = JSON.parse(JSON.stringify(const_var.extraAddOnItemsArray ?? []));

			const_var.lNTBuildingData.updatePriceDataElements.centerBuilding = const_var.UpdatedPriceData.elements;
			utils.prepareLoftDropdown();
			if (const_var.leanto_condition_by_mfg?.gable_building_without_pricing == 1) {
				const_var.isLTBuilding = true;
				dispatch(buildingStyleChangeAccordingtoType(const_var.BuldingIDforReset, const_var.post_data.building.building_type, true));
			}
		}

		dispatch({
			type: "changeLeanStyle",
			leanType: leanType,
			leanStyle: "gable"
		});

		dispatch({
			type: "addLeantoSection",
			value: str,
			from: "changeStyle"
		});

		response = await dispatch(getPricingDataForLeanto(true, str));

		dispatch(selectLeanBuilding(leanType));

		return response;
	};
}

export function removeLTExtension(leanType) {
	return async (dispatch) => {
		let response = null;
		const str = `add${utils.capitalize(leanType)}Lean`;

		const willHaveGableLeft = ["left", "right", "front", "back"].filter((l) => l !== leanType).find((lean) => params.leanStyle[lean] === "gable");
		const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation[leanType] = [];
		const_var[`leanGetData${utils.capitalize(leanType)}`] = "";

		if (!willHaveGableLeft) {
			const_var.ExtraItemsFeaturesQuantityArray = JSON.parse(JSON.stringify(const_var.lNTBuildingData.ExtraItemsFeaturesQuantityArray.centerBuilding ?? []));
			const_var.UpdatedPriceData.elements = JSON.parse(JSON.stringify(const_var.lNTBuildingData.updatePriceDataElements.centerBuilding ?? {}));
		}

		if (leanType === "right") {
			const_var.extraAddOnItemsArrayList.right = [];
			const_var.lNTBuildingData.extraAddOnItemsArray.right = [];
			const_var.insulationArrayForLeantoRight = [];
			params.added_building_bracing.p_e_c_b_r = false;
			params.added_building_bracing.p_s_c_b_r = false;
			const_var.selectedBracingForAddedBuilding["right_lean_end"] = "";
			const_var.selectedBracingForAddedBuilding["right_lean_side"] = "";
			const_var.LNTCrossBracing["right"] = [];
			const_var.selLoftVal.right = 4;
			const_var.loft_value_array.right = [];
		}
		if (leanType === "left") {
			const_var.extraAddOnItemsArrayList.left = [];
			const_var.lNTBuildingData.extraAddOnItemsArray.left = [];
			const_var.insulationArrayForLeantoLeft = [];
			params.added_building_bracing.p_e_c_b_l = false;
			params.added_building_bracing.p_s_c_b_l = false;
			const_var.selectedBracingForAddedBuilding["left_lean_end"] = "";
			const_var.selectedBracingForAddedBuilding["left_lean_side"] = "";
			const_var.LNTCrossBracing["left"] = [];
			const_var.selLoftVal.left = 4;
			const_var.loft_value_array.left = [];
		}
		if (leanType === "front") {
			const_var.extraAddOnItemsArrayList.front = [];
			const_var.lNTBuildingData.extraAddOnItemsArray.front = [];
			const_var.insulationArrayForLeantoFront = [];
			params.added_building_bracing.p_e_c_b_f = false;
			params.added_building_bracing.p_s_c_b_f = false;
			const_var.selectedBracingForAddedBuilding["front_lean_end"] = "";
			const_var.selectedBracingForAddedBuilding["front_lean_side"] = "";
			const_var.LNTCrossBracing["front"] = [];
			const_var.selLoftVal.front = 4;
			const_var.loft_value_array.front = [];
		}
		if (leanType === "back") {
			const_var.extraAddOnItemsArrayList.back = [];
			const_var.lNTBuildingData.extraAddOnItemsArray.back = [];
			const_var.insulationArrayForLeantoBack = [];
			params.added_building_bracing.p_e_c_b_b = false;
			params.added_building_bracing.p_s_c_b_b = false;
			const_var.selectedBracingForAddedBuilding["back_lean_end"] = "";
			const_var.selectedBracingForAddedBuilding["back_lean_side"] = "";
			const_var.LNTCrossBracing["back"] = [];
			const_var.selLoftVal.back = 4;
			const_var.loft_value_array.back = [];
		}

		if (!willHaveGableLeft && const_var.isLNTBuildingIsCustom) {
			const_var.isLTBuilding = false;
			dispatch(buildingStyleChangeAccordingtoType(const_var.BuldingIDforReset, const_var.post_data.building.building_type, true));
		} else {
			dispatch({
				type: "changeLeanStyle",
				leanType: leanType,
				leanStyle: "standard"
			});

			if (const_var.selectedLeanType === leanType) {
				dispatch(selectCenterBuilding());
			}

			dispatch({
				type: "addLeantoSection",
				value: str
			});

			response = await dispatch(getPricingDataForLeanto(true, str));
		}

		return response;
	};
}

export function getInsulation(e, value) {
	let apiData = {};
	let customRoofPitch = e == undefined ? params.b_r_p.split("").slice(0, -2).join("") : e.split("").slice(0, -2).join("");
	if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to")) {
		if (const_var.post_data.building.utility_name != "back") {
			apiData = {
				map_id: const_var.Map_Id[params.p_b_t],
				manufacturer_id: params.m_s_n,
				building_id: params.p_b_t,
				roof_id: params.p_r_s,
				height: params.p_h,
				width: params.p_b_t == "2" ? params.p_w + 24 : params.p_w,
				length: params.p_d,
				is_leanto: 0,

				utility_width: params.cB_addStorage_check_left || params.cB_addStorage_check_right ? (params.p_b_t == "2" ? (params.p_w + 24) / 2 : params.p_w / 2) : 0,
				single_slope_height:
					const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
						? Math.floor(params.p_h - (params.p_w * params.p_r_p) / 12)
						: Math.round(params.p_h - (params.p_w * params.p_r_p) / 12),
				pitch_height: Math.round(parseFloat(params.p_h) + parseFloat(params.p_r_p)),
				pitch_type: `${customRoofPitch}_12`
			};
		} else {
			apiData = {
				map_id: const_var.Map_Id[params.p_b_t],
				manufacturer_id: params.m_s_n,
				building_id: params.p_b_t,
				roof_id: params.p_r_s,
				height: params.p_h,
				width: params.p_b_t == "2" ? params.p_w + 24 : params.p_w,
				length: params.p_d,
				is_leanto: 0,

				utility_length: params.p_u_c == true ? params.p_u_t : 0,
				single_slope_height:
					const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
						? Math.floor(params.p_h - (params.p_w * params.p_r_p) / 12)
						: Math.round(params.p_h - (params.p_w * params.p_r_p) / 12),
				pitch_type: `${customRoofPitch}_12`
			};
		}
	} else {
		if (value != "addRightLean" && value != "addLeftLean" && value != "addFrontLean" && value != "addBackLean" && const_var.post_data.building.utility_name != "back") {
			apiData = {
				map_id: const_var.Map_Id[params.p_b_t],
				manufacturer_id: params.m_s_n,
				building_id: params.p_b_t,
				roof_id: params.p_r_s,
				height: params.p_h,
				width: params.p_b_t == "2" ? params.p_w + 24 : params.p_w,
				length: params.p_d,
				is_leanto: 0,

				utility_width: params.cB_addStorage_check_left || params.cB_addStorage_check_right ? (params.p_b_t == "2" ? (params.p_w + 24) / 2 : params.p_w / 2) : 0,
				pitch_height: Math.round(parseFloat(params.p_h) + parseFloat(params.p_r_p)),
				pitch_type: `${customRoofPitch}_12`
			};
		} else {
			let is_leanto = 0;
			let height = params.p_h;
			let length = params.p_d;
			let roof_id = params.p_r_s;
			let utility_length = params.p_u_c == true ? params.p_u_t : 0;
			let width = params.p_b_t == "2" ? params.p_w + 24 : params.p_w;
			let pitch_type = `${customRoofPitch}_12`;
			if (value == "addRightLean") {
				height = params.leanR_p_h;
				length = params.leanR_p_d;
				width = params.leanR_p_w;
				utility_length = params.add_storage_check_right == true ? params.add_storage_right : 0;

				pitch_type = `${params.b_l_t_r_pR}_12`;
				is_leanto = 1;
			}
			if (value == "addLeftLean") {
				height = params.lean_p_h;
				length = params.lean_p_d;
				width = params.lean_p_w;
				utility_length = params.add_storage_check == true ? params.add_storage : 0;

				pitch_type = `${params.b_l_t_r_p}_12`;
				is_leanto = 1;
			}
			if (value == "addFrontLean") {
				height = params.leanF_p_h;
				length = params.leanF_p_d;
				width = params.leanF_p_w;
				utility_length = params.add_storage_check_front == true ? params.add_storage_front : 0;

				pitch_type = `${params.b_l_t_r_pF}_12`;
				is_leanto = 1;
			}
			if (value == "addBackLean") {
				height = params.leanB_p_h;
				length = params.leanB_p_d;
				width = params.leanB_p_w;
				utility_length = params.add_storage_check_back == true ? params.add_storage_back : 0;

				pitch_type = `${params.b_l_t_r_pB}_12`;
				is_leanto = 1;
			}
			apiData = {
				map_id: const_var.Map_Id[params.p_b_t],
				manufacturer_id: params.m_s_n,
				building_id: params.p_b_t,
				roof_id: roof_id, //params.p_r_s,
				height: height, //params.p_h,
				width: width, //(params.p_b_t =="2")?params.p_w+24:params.p_w,
				length: length, //params.p_d,
				is_leanto: (is_leanto = 1),
				// "is_leanto": params.add_front_lean || params.add_back_lean || params.add_left_lean || params.add_right_lean ? 1 : 0,
				utility_length: utility_length, //(params.p_u_c==true)?params.p_u_t:0,
				pitch_type: pitch_type //`${customRoofPitch}_12`
			};
		}
	}
	if (apiData != undefined && apiData.pitch_height != undefined) {
		if (apiData.pitch_height > 20) {
			apiData.pitch_height = 20;
		}
	}
	if (value != "addRightLean" && value != "addLeftLean" && value != "addFrontLean" && value != "addBackLean" && customRoofPitch != "") {
		insulationApi(apiData, "centerBuilding", value);
	}
	if (value == "addRightLean" || value == "addLeftLean" || value == "addFrontLean" || value == "addBackLean") {
		insulationApi(apiData, value, value);
	}
}

export function insulationApi(apiData, from, hitFrom) {
	if (from == "lean") {
		apiData.building_id = params.p_b_t;
		apiData.is_leanto = "1";
		apiData.manufacturer_id = params.m_s_n;
		if (hitFrom == "addLeftLean") {
			apiData.pitch_type = params.b_l_t_r_p + "_12";
		}
		if (hitFrom == "addFrontLean") {
			apiData.pitch_type = params.b_l_t_r_pF + "_12";
		}
		if (hitFrom == "addBackLean") {
			apiData.pitch_type = params.b_l_t_r_pB + "_12";
		}
		if (hitFrom == "addRightLean") {
			apiData.pitch_type = params.b_l_t_r_pR + "_12";
		}
	}
	/*SE3-I4117 Lean insulation price is displaying on custom building type under non logged Start*/
	if (const_var.b_o_J_1[params.p_b_t] == "Custom Buildings") {
		apiData.is_lean_to_price = true;
	}
	/*SE3-I4117 Lean insulation price is displaying on custom building type under non logged End*/
	return axios
		.post(`${const_var.crmSetting.price_api_url}get-insulation`, apiData, { headers: const_var.crmSetting.header_key })
		.then(function (response) {
			if (from == "centerBuilding") {
				if (
					params.p_i_o != 0 &&
					response?.data?.data != undefined &&
					response.data.data?.length > 0 &&
					const_var.isInsulaltionForOldQuotes == false &&
					const_var.crmSetting.is_Edit == true &&
					response.data.data.filter((obj) => obj.insulation_id == params.p_i_o).length == 0
				) {
					params.p_i_o = response.data.data[0].insulation_id; //0
					params.selectedInsulationId = response.data.data[0].insulation_id;
					params.insulation.center.isCheked = false;
					params.insulation.center.insulationId = 0;
					params.insulation.center.roofOnly = false;
					params.insulation.center.fullBuilding = false;
					params.insulation.center.custom = false;
					params.insulation.center.showInsulationOptions = false;
					params.insulation.center.isDisableFullInsulation = false;
				}
				if (const_var?.a_p_d_a && const_var.a_p_d_a?.insulation != undefined) {
					const_var.cbInsulation = response.data.data;
					const_var.CompleteDataPricing = {};
					const_var.CompleteDataPricing.data = {};
					const_var.CompleteDataPricing.data.data = const_var.a_p_d_a;
					const_var.CompleteDataPricing.data.data.insulation = response.data.data;
					if (const_var.post_data.building !== undefined && const_var.post_data.building.leanto.length > 0) {
						for (var i = 0; i <= const_var.post_data.building.leanto.length - 1; i++) {
							const_var.post_data.building.leanto[i].pricing_data.central_insulation = response.data.data;
						}
					}
					const_var.UpdatedPriceData.insulation_price_changed = true;
					cuBuilding.makeExtraElements();
					const_var.UpdatedPriceData.insulation_price_changed = true;
					const_var.UpdatedPriceData.insulation_price = undefined;
					let filterNewdata = response?.data?.data.filter((inc) => {
						if (const_var.post_data.building.insulation_type != undefined && inc.insulation_id == const_var.post_data.building.insulation_type.insulation_id) {
							return inc;
						}
					});
					if (filterNewdata != undefined && filterNewdata?.length > 0) {
						const_var.post_data.building.insulation_type = filterNewdata[0];
					}
					checkAndupdateOtherInsulationSelection(response.data.data);
					cuBuilding.cP();
				}
			} else {
				if (hitFrom == "addFrontLean" && params.add_front_lean == true) {
					const_var.leanGetDataFront.insulation = response.data.data;
					const_var.UpdatedPriceData.insulation_price_changed = true;
					const_var.UpdatedPriceData.insulation_price = undefined;
					const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
					if (!Array.isArray(const_var.insulationArrayForLeantoFront)) {
						const_var.insulationArrayForLeantoFront = [];
					}
					for (var i = 0; i <= const_var.leanGetDataFront.insulation?.length - 1; i++) {
						const_var.insulationArrayForLeantoFront[const_var.leanGetDataFront.insulation[i].insulation_id] = JSON.parse(JSON.stringify(const_var.leanGetDataFront.insulation[i]));
					}
					const_var.insulationJsonLeanTo = [];
					for (var i = 0; i <= const_var.leanGetDataFront.insulation?.length - 1; i++) {
						const_var.insulationJsonLeanTo[const_var.leanGetDataFront.insulation[i].insulation_id] = const_var.leanGetDataFront.insulation[i].name;
					}
					cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
				}
				if (hitFrom == "addBackLean" && params.add_back_lean == true) {
					const_var.leanGetDataBack.insulation = response.data.data;
					const_var.UpdatedPriceData.insulation_price_changed = true;
					const_var.UpdatedPriceData.insulation_price = undefined;
					const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
					if (!Array.isArray(const_var.insulationArrayForLeantoBack)) {
						const_var.insulationArrayForLeantoBack = [];
					}
					for (var i = 0; i <= const_var.leanGetDataBack.insulation?.length - 1; i++) {
						const_var.insulationArrayForLeantoBack[const_var.leanGetDataBack.insulation[i].insulation_id] = JSON.parse(JSON.stringify(const_var.leanGetDataBack.insulation[i]));
					}
					const_var.insulationJsonLeanTo = [];
					for (var i = 0; i <= const_var.leanGetDataBack.insulation?.length - 1; i++) {
						const_var.insulationJsonLeanTo[const_var.leanGetDataBack.insulation[i].insulation_id] = const_var.leanGetDataBack.insulation[i].name;
					}
					cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
				}
				if (hitFrom == "addLeftLean" && params.add_left_lean == true) {
					const_var.leanGetDataLeft.insulation = response.data.data;
					const_var.UpdatedPriceData.insulation_price_changed = true;
					const_var.UpdatedPriceData.insulation_price = undefined;
					const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
					if (!Array.isArray(const_var.insulationArrayForLeantoLeft)) {
						const_var.insulationArrayForLeantoLeft = [];
					}
					for (var i = 0; i <= const_var.leanGetDataLeft.insulation?.length - 1; i++) {
						const_var.insulationArrayForLeantoLeft[const_var.leanGetDataLeft.insulation[i].insulation_id] = JSON.parse(JSON.stringify(const_var.leanGetDataLeft.insulation[i]));
					}
					const_var.insulationJsonLeanTo = [];
					for (var i = 0; i <= const_var.leanGetDataLeft.insulation?.length - 1; i++) {
						const_var.insulationJsonLeanTo[const_var.leanGetDataLeft.insulation[i].insulation_id] = const_var.leanGetDataLeft.insulation[i].name;
					}
					cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
				}
				if (hitFrom == "addRightLean" && params.add_right_lean == true) {
					const_var.leanGetDataRight.insulation = response.data.data;
					const_var.UpdatedPriceData.insulation_price_changed = true;
					const_var.UpdatedPriceData.insulation_price = undefined;
					const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
					if (!Array.isArray(const_var.insulationArrayForLeantoRight)) {
						const_var.insulationArrayForLeantoRight = [];
					}
					for (var i = 0; i <= const_var.leanGetDataRight.insulation?.length - 1; i++) {
						const_var.insulationArrayForLeantoRight[const_var.leanGetDataRight.insulation[i].insulation_id] = JSON.parse(JSON.stringify(const_var.leanGetDataRight.insulation[i]));
					}
					const_var.insulationJsonLeanTo = [];
					for (var i = 0; i <= const_var.leanGetDataRight.insulation?.length - 1; i++) {
						const_var.insulationJsonLeanTo[const_var.leanGetDataRight.insulation[i].insulation_id] = const_var.leanGetDataRight.insulation[i].name;
					}
					cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
				}
			}
		})
		.catch((err) => {
			console.log(err);
		});
}